export default [
  {label: 'Less than $5,000', value: 'Less than $5,000'},
  {label: '$5,000 - $10,000', value: '$5,000 - $10,000'},
  {label: '$10,000 - $20,000', value: '$10,000 - $20,000'},
  {label: '$20,000 - $50,000', value: '$20,000 - $50,000'},
  {label: '$50,000 - $100,000', value: '$50,000 - $100,000'},
  {label: 'Greater than $100,000', value: 'Greater than $100,000'},
];
